import React, {Component} from "react";
import {connect} from "react-redux";

import {VIEWS} from "./../../helpers/consts";

import SVGIcon from "../svg/SVGIcon";

import "./SelectedItem.css";

class SelectedItem extends Component {

  constructor(props) {
    super();
    this.getLabel = this.getLabel.bind(this);
  }

  getLabel(){
    const {selectedCluster, selectedOccupation, selectedRegion, hashParts} = this.props;
    const selectedRegional = selectedCluster || selectedRegion;
    const selected = hashParts;
    let label = false;
    if (selected.view === VIEWS.EMPLOYMENT){
    } else if (selected.view === VIEWS.REGIONAL_CLUSTER) {
      label = selectedRegional.name;
    } else if (selected.view === VIEWS.OCCUPATIONAL) {
      label = selectedOccupation.name;
    }
    return label;
  }

  render() {
    const {hash} = this.props;
    if (!hash){
      return '';
    }
    const label = this.getLabel();
    return (
      <div className="fow-chart-selected-item">
        {label &&
          <>
            <SVGIcon name="eye" width="30" height="20" stroke="#888" fill="transparent" /><div className="fow-chart-selected-item-label fow-font-text fow-font-size-md">{label}</div>
          </>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hash: state.settings.hash,
    hashParts: state.settings.hashParts,
    selectedRegion: state.settings.map["Regions"],
    selectedCluster: state.settings.map["Clusters"],
    selectedOccupation: state.settings.map["Occupations"],
  };
};
const mapDispatchToProps = dispatch => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(SelectedItem);
